import type { Dayjs } from "@/lib/dayjs";
import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { createCalendarDay } from "./create-calendar-day";

import type { CalendarDayType } from "./types";

export function createPreviousMonthDays(firstDay: Dayjs, lang: LangCode): CalendarDayType[] {
	const day = firstDay.day();
	if (day === 0) return [];

	const dates: CalendarDayType[] = [];
	for (let i = day; i > 0; i--) {
		const date = firstDay.subtract(i + 1, "day");
		dates.push(createCalendarDay({ date, lang, isDifferentMonth: true }));
	}
	return dates;
}

export function createCurrentMonthDays(firstDay: Dayjs, lastDay: Dayjs, lang: LangCode): CalendarDayType[] {
	const dates: CalendarDayType[] = [];
	for (let date = firstDay; date <= lastDay; date = date.add(1, "day")) {
		dates.push(createCalendarDay({ date, lang }));
	}
	return dates;
}

export function createNextMonthDays(lastDay: Dayjs, lang: LangCode): CalendarDayType[] {
	const day = lastDay.day();
	if (day === 6) return [];

	const dates: CalendarDayType[] = [];
	for (let i = day, addValue = 1; i < 6; i++, addValue++) {
		const date = lastDay.add(addValue, "day");
		dates.push(createCalendarDay({ date, lang, isDifferentMonth: true }));
	}
	return dates;
}
